import { useEffect, useState } from 'react'
import { withAuthRecovery } from '@/lib/authRecovery'
import { getSupabase } from '@/lib/supabase'
import { useAuthStore } from '@/store'

export function useNetworkPlanningAccess(): { canViewNetworkPlanning: boolean | undefined } {
  const user = useAuthStore(state => state.user)
  const [canViewNetworkPlanning, setCanViewNetworkPlanning] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    let cancelled = false

    if (!user?.id) {
      setCanViewNetworkPlanning(false)
      return
    }

    setCanViewNetworkPlanning(undefined)
    void (async () => {
      try {
        const { data, error } = await withAuthRecovery(() =>
          (getSupabase() as any).rpc('network_planning_can_view')
        ) as { data: boolean | null; error: unknown }
        if (!cancelled) setCanViewNetworkPlanning(!error && data === true)
      } catch {
        if (!cancelled) setCanViewNetworkPlanning(false)
      }
    })()

    return () => { cancelled = true }
  }, [user?.id])

  return { canViewNetworkPlanning }
}
